import {
  fetchCategoryImagesAsync,
  setCurrentModal,
  toggleModal,
  setImgId,
} from "@/store/slices/GlobalSlice";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import BtnShare from "../BtnShare";

const TownGalleryItems = (props) => {
  const dispatch = useDispatch();
  const { latestHouseImages } = useSelector((state) => state.globalSlice);

  const handleImgClick = (cateID, imgID) => {
    dispatch(setImgId(imgID));
    dispatch(toggleModal());
    dispatch(fetchCategoryImagesAsync(cateID));
    dispatch(setCurrentModal("townSlider"));
  };

  return (
    <div className="relative pb-3">
      <div className="relative pb-28 md:pb-0 overflow-x-auto">
        <div className="min-h-100 flex md:flex-wrap gap-4 justify-center items-center absolute left-1/2 transform -translate-x-1/3 md:static md:transform-none">
          {latestHouseImages?.map((item, index) => {
            return (
              <figure className="h-100 w-100" key={index}>
                <img
                  className="w-full h-full rounded-full object-cover object-center cursor-pointer"
                  src={item.url}
                  alt="image"
                  onClick={() => handleImgClick(item.main_category_id, item.id)}
                />
              </figure>
            );
          })}
        </div>
      </div>

      <BtnShare />
    </div>
  );
};

TownGalleryItems.propTypes = {};

export default TownGalleryItems;
